module.exports = __webpack_public_path__ + "static/media/mobile-android.54c13da0.svg";